import { CheckoutJourney } from '../models/checkout-journey.types';
import { CustomerJourneyType } from '../models/checkout.model';

export const FREE_BOOKING_JOURNEY: CheckoutJourney = {
  type: CustomerJourneyType.FREE_BOOKING,
  searchRoute: '/search',
  page: [
    {
      pageRoute: 'addons',
      label: 'Tilvalg',
      ariaLabel: 'Tilvalg',
    },
    {
      pageRoute: 'personal-info',
      label: 'Personlig info',
      ariaLabel: 'Personlig info',
      // Override "Videre til betaling" from availability-type config — there is no payment step
      zoneConfig: {
        actions: [
          {
            id: 'next',
            buttonLabel: 'Bekræft booking',
          },
        ],
        processingLabel: 'Gennemfører tilmelding...',
      },
    },
    {
      pageRoute: 'complete',
      label: 'Bekræftelse',
      ariaLabel: 'Bekræftelse',
      zoneConfig: {
        summaryContent: {
          title: 'Booking bekræftet',
          message: 'Vi glæder os til at se dig.',
          illustrationPath: './assets/illustrations/checkout-goalline.svg',
        },
      },
    },
  ],
};
